// this file is generated by update_shopify_store_data.py at 2026-06-22 20:34:22.868937
var courses = [
    {
        "course_id": "370EDDF8-6EC9-F011-99A1-005056A730AF",
        "course_version": 2,
        "name": "Springer Publishing - SCRN\u00ae Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Stroke Certified Registered Nurse (SCRN) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nSCRN\u00ae is a registered trademark of the American Board of Neuroscience Nursing (ABNN). The ABNN does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas related to neuroscience and stroke nursing practice.</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to patient-care scenarios across the hyperacute, acute, and post acute phases of stroke management.</li>\r\n    <li>Demonstrate readiness for the SCRN&reg; certification exam through self-assessment activities.</li>\r\n</ul>",
        "course_outline_html": "<li>Introduction</li>\r\n<li>Module 1: Certification Exam</li>\r\n<li>Module 2: Anatomy, Physiology, and Etiology of Strokes</li>\r\n<li>Module 3: Associated Stroke Disorders</li>\r\n<li>Module 4: Hyperacute Stroke Care</li>\r\n<li>Module 5: Stroke Diagnostics</li>\r\n<li>Module 6: Neurological and Functional Assessment and Severity Scores</li>\r\n<li>Module 7: Acute Stroke Care</li>\r\n<li>Module 8: Medications</li>\r\n<li>Module 9: Post-acute Stroke Care</li>\r\n<li>Module 10: Primary and Secondary Preventive Care</li>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E32CF83-389F-11DD-AD08-0015171C1B93",
                "course_category_name": "Neurological & Neurocognitive Disorders",
                "is_system_course_category": null
            },
            {
                "course_category_id": "235953F6-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neurosurgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D6D72E5-07DB-E511-AA9E-005056B17E48",
                "course_category_name": "Neurological Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Rehabilitation",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];